const Person = resolve => require(['@/containers/Person'], resolve)
const Menber = resolve => require(['@/containers/Person/VipMember'], resolve)
const StudyRecord = resolve => require(['@/containers/Person/StudyRecord'], resolve)
const StudyPlan = resolve => require(['@/containers/Person/StudyPlan'], resolve)
const PlanList = resolve => require(['@/containers/Person/PlanList'], resolve)
const MakeUpRegistration = resolve => require(['@/containers/Person/MakeUpRegistration'], resolve)
const Apply = resolve => require(['@/containers/Person/MakeUpRegistration/Apply'], resolve)
const payList = resolve => require(['@/containers/Person/PayList'], resolve)
const PayDetail = resolve => require(['@/containers/Person/PayDetail'], resolve)
const OrderInfo = resolve => require(['@/containers/Person/OrderInfo'], resolve)
const Certificate = resolve => require(['@/containers/Person/Certificate'], resolve)
const CertList = resolve => require(['@/containers/Person/Certificate/CertList'], resolve)
const PersonInfo = resolve => require(['@/containers/Person/PersonInfo'], resolve)
const EditePage = resolve => require(['@/containers/Person/PersonInfo/EditePage'], resolve)
const PlanDetails = resolve => require(['@/components/Common/PlanDetails'], resolve)
const ExamApply = resolve => require(['@/containers/Person/ExamApply'], resolve)
const Ticket = resolve => require(['@/containers/Person/ExamApply/Ticket'], resolve)
const routes = [{
  path: '/person',
  name: 'Person',
  component: Person,
  meta: {
    hasHeader: false,
    hasFooter: true,
    login: true
  }
},
{
  path: '/menber',
  name: 'Menber',
  component: Menber,
  meta: {
    login: true,
    hasFooter: true,
    title: '会员中心',
    hasBack: true
  }
},
{
  path: '/pay_list',
  name: 'payList',
  component: payList,
  meta: {
    login: true,
    hasBack: true,
    title: '缴费列表'
  }
},
{
  path: '/pay_detail',
  name: 'PayDetail',
  component: PayDetail,
  meta: {
    login: true,
    hasBack: true,
    title: '订单详情'
  }
},
{
  path: '/study',
  name: 'study_record',
  component: StudyRecord,
  meta: {
    login: true,
    hasBack: true,
    title: '学习记录'
  }
},
{
  path: '/plan',
  name: 'Study_Plan',
  component: StudyPlan,
  meta: {
    login: true,
    hasBack: true,
    title: '学习计划'
  }
},
{
  path: '/plan_details',
  name: 'Plan_Details',
  component: PlanDetails,
  meta: {
    login: true,
    hasBack: true,
    title: '计划详情'
  }
},
{
  path: '/plan_list',
  name: 'PlanList',
  component: PlanList,
  meta: {
    login: true,
    hasBack: true,
    title: '计划列表'
  }
},
{
  path: '/makeUp_registration',
  name: 'MakeUpRegistration',
  component: MakeUpRegistration,
  meta: {
    login: true,
    hasBack: true,
    title: '测评成绩'
  }
},
{
  path: '/order_info',
  name: 'OrderInfo',
  component: OrderInfo,
  meta: {
    login: true,
    hasBack: true,
    title: '订单信息'
  }
},
{
  path: '/personinfo',
  name: 'PersonInfo',
  component: PersonInfo,
  meta: {
    login: true,
    hasBack: true,
    title: '个人信息'
  }
},
{
  path: '/edite-page',
  name: 'EditePage',
  component: EditePage,
  meta: {
    login: true,
    hasHeader: false
  }
},
{
  path: '/certificate',
  name: 'Certificate',
  component: Certificate,
  meta: {
    login: true,
    hasBack: true,
    hasFooter: false,
    title: '结业证书'
  }
},
  {
    path: '/certList',
    name: 'CertList',
    component: CertList,
    meta: {
      login: true,
      hasBack: true,
      title: '自评合格列表'
    }
  },
  {
    path: '/apply',
    name: 'Apply',
    component: Apply,
    meta: {
      login: true,
      hasBack: true,
      title: '测评系统报名'
    }
  },
  {
    path: '/examApply',
    name: 'examApply',
    component: ExamApply,
    meta: {
      login: true,
      hasBack: true,
      title: '考试报名'
    }
  },
  {
    path: '/ticket',
    name: 'ticket',
    component: Ticket,
    meta: {
      login: true,
      hasBack: true,
      title: '准考证'
    }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/person.js